// probably not the best example but simple way to accomplish capture
$(document).on("swell:setup", function(){

  var existingEmailField = $(".contact-form .contact_email");
  var existingSubmitBtn = $(".contact-form .sign_up");

  $(existingSubmitBtn).click(function(){
    var email = existingEmailField.val();
    swellAPI.captureNewsletterSignup(email);
    console.log("clicked");
  });

});
